export const isEmptyString = (s: string): boolean => s.length === 0
